import { Button } from "@/components/ui/Button";
import { JOIN_AS_PRO_URL } from "../../constants/urls";
import { SlotsToClasses } from "@nextui-org/react";
import { cn } from "@/libs/utils/tailwind/cn";
import GooglePlayIcon from "./assets/GooglePlayIcon";
import AppleStoreIcon from "./assets/AppleStoreIcon";
import { prependCdnResourcesUrl } from "@/utils/network";

const APP_STORE_IOS_URL =
  "https://apps.apple.com/us/app/networx-pros/id1073588587";
const APP_STORE_ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.networxpros.app";

export default function LevelUpYourBusinessSection({
  className,
  classNames,
}: LevelUpYourBusinessSectionProps) {
  return (
    <section
      className={cn(
        "overflow-hidden bg-default-100 pt-12 pb-14",
        classNames?.base,
        className
      )}
    >
      <div
        className={cn(
          "flex min-h-[520px] items-center gap-10 sm:gap-2 flex-col-reverse lg:flex-row lg:pb-14",
          classNames?.container
        )}
      >
        <div className="flex flex-col grow sm:items-center sm:text-center lg:items-start lg:text-left lg:mt-12 px-4">
          <div className="mb-8 sm:mb-12 flex flex-wrap sm:items-center sm:justify-center gap-6 lg:justify-start">
            <a
              href={APP_STORE_ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get Networx Pros on Google Play"
            >
              <GooglePlayIcon className="h-[50px] w-auto" />
            </a>
            <a
              href={APP_STORE_IOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download Networx Pros on the App Store"
            >
              <AppleStoreIcon className="h-[50px] w-auto" />
            </a>
          </div>

          <h2 className="max-w-2xl text-[28px] font-semibold leading-tight tracking-tight text-foreground sm:text-5xl lg:text-[52px]">
            Level up your <br />business with Networx.
          </h2>

          <div className="mt-10 flex max-w-[364px] flex-col gap-6 text-base sm:text-lg leading-snug text-foreground">
            <p>Get real time access to our exclusive network of local jobs.</p>
            <p>
              We offer the best-in-class tools, tips, and services to help your
              business thrive.
            </p>
          </div>

          <Button
            as="a"
            href={JOIN_AS_PRO_URL}
            variant="bordered"
            radius="lg"
            className="mt-8 ml-0 h-14 min-w-28 w-fit !border-1 !border-solid border-foreground bg-transparent px-6 text-lg font-semibold !text-foreground"
          >
            Join us
          </Button>
        </div>

        <div className="relative flex sm:min-h-[420px] max-w-[386px] justify-center lg:justify-end">
          <img
            src={prependCdnResourcesUrl("/images/networx/homepage/level-up-your-business-section/leads-phone-preview.png")}
            alt="Networx Pros App - Leads Preview"
            className="w-[264px] h-auto max-w-full sm:w-[360px] lg:w-[410px]"
          />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-default-100 to-transparent" />
        </div>
      </div>
    </section>
  );
}

interface LevelUpYourBusinessSectionProps {
  className?: string;
  classNames?: SlotsToClasses<"base" | "container">;
}
